import laoChartConstants from "reduxLib/constants/LAO/laoChartConstants";

const initialState = {}

const laoChartsReducer = (state = initialState, action) => {
    switch (action.type) {
        case laoChartConstants.LAO_CHARTS_LOADING:
            return {
                ...state,
                [action.subtype]: {
                    ...state[action.subtype],
                    loading: action.payload,
                }

            };

        case laoChartConstants.LAO_GET_EXPORT_CHART_SUCCESS:
        case laoChartConstants.LAO_GET_EXPORT_CHART_FAILED:
            return {
                ...state,

                [action.subtype]: {
                    ...state[action.subtype],
                    status: action.status,
                    data: action.payload,
                    loading: false,
                }
            };

        default:
            return state;
    }
}

export default laoChartsReducer;  